/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import SectionHeader from './SectionHeader';
import TextEditor from 'client/src/components/textEditor';

import './PhotoStyles.scss';

type PropsType = {
  onHandleChangeText: () => void,
  editablePart?: any,
  isSubmited: boolean,
  onHandleSetLocked: () => void
};

const Text = (props: PropsType): React.Element => {
  const { onHandleChangeText, editablePart, isSubmited, onHandleSetLocked } = props;
  const firstUpdate = React.useRef(true);
  const limit = 7500;

  React.useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    }
  }, [isSubmited]);

  return (
    <>
      <SectionHeader {...props} onHandleChange={onHandleChangeText} title={_.get(editablePart, 'link_label') || 'Text'}/>

      <div className="row">
        <div className="col-xs-12">
          <TextEditor
            value={_.get(editablePart, 'text') || ''}
            limit={limit}
            onChange={
              (data: any): void => onHandleChangeText({ text: data })
            }
            handleSetValidationError={onHandleSetLocked}
          />
        </div>
      </div>
    </>
  );
};

export default Text;
